// import SalesOrderLineInterface from '@/interfaces/SalesOrderLineInterface';

// const LinesUtility = {
//   getProductKey(line: SalesOrderLineInterface) {
//     return `${line.No}|${line.Item_No_2}`;
//   },
//   getMainLines({ lines = [] }: { lines: Array<SalesOrderLineInterface> }) {
//     return Array.from(
//       lines
//         .reduce((products, currentLine) => {
//           const productKey = this.getProductKey(currentLine);
//           const currentMainLine = products.get(productKey);

//           if (!currentMainLine || this.isPersonalised(currentLine) === false) {
//             products.set(productKey, currentLine);
//           }

//           return products;
//         }, new Map<string, SalesOrderLineInterface>())
//         .values(),
//     );
//   },
//   getMatchingLines({ lines = [], line }: { lines: Array<SalesOrderLineInterface>; line: SalesOrderLineInterface }) {
//     return lines.filter((l) => l.No === line.No && l.Item_No_2 === line.Item_No_2);
//   },
//   getMatchingLinesPersonalised({
//     lines = [],
//     line,
//   }: {
//     lines: Array<SalesOrderLineInterface>;
//     line: SalesOrderLineInterface;
//   }) {
//     return this.getMatchingLines({ lines, line }).filter((l) => this.isPersonalised(l));
//   },
//   getMatchingLinesPersonalisedPiecesCount({
//     lines = [],
//     line,
//   }: {
//     lines: Array<SalesOrderLineInterface>;
//     line: SalesOrderLineInterface;
//   }) {
//     return this.getMatchingLinesPersonalised({ lines, line }).reduce((sum, item) => sum + Number(item.Quantity), 0);
//   },
//   getMatchingLinesTotalQuantity(line: SalesOrderLineInterface) {
//     const { Initial_Quantity = 0 } = line;
//     return Initial_Quantity;
//   },
//   getMatchingLinesPiecesLeftToPersonaliseQuantity({
//     lines = [],
//     line,
//   }: {
//     lines: Array<SalesOrderLineInterface>;
//     line: SalesOrderLineInterface;
//   }) {
//     return +this.getMatchingLinesTotalQuantity(line) - this.getMatchingLinesPersonalisedPiecesCount({ lines, line });
//   },
//   isPersonalised(line: SalesOrderLineInterface) {
//     return Boolean(line.Line_Notes?.trim());
//   },
// };

// export default LinesUtility;

// import SalesOrderLineInterface from '@/interfaces/SalesOrderLineInterface';

// const LinesUtility = {
//   productKey(line: SalesOrderLineInterface) {
//     return `${line.No}|${line.Item_No_2}`;
//   },

//   mainLines(lines: SalesOrderLineInterface[] = []) {
//     return Array.from(
//       lines
//         .reduce((products, line) => {
//           const key = this.productKey(line);
//           const existingLine = products.get(key);

//           if (!existingLine || this.isPersonalised(line) === false) products.set(key, line);

//           return products;
//         }, new Map<string, SalesOrderLineInterface>())
//         .values(),
//     );
//   },

//   mainLine(lines: SalesOrderLineInterface[], line: SalesOrderLineInterface) {
//     return this.mainLines(lines).find((l) => l.No === line.No && l.Item_No_2 === line.Item_No_2);
//   },

//   productLines(lines: SalesOrderLineInterface[], line: SalesOrderLineInterface) {
//     return lines.filter((item) => item.No === line.No && item.Item_No_2 === line.Item_No_2);
//   },

//   personalisedLines(lines: SalesOrderLineInterface[], line: SalesOrderLineInterface) {
//     return this.productLines(lines, line).filter((item) => this.isPersonalised(item));
//   },

//   personalisedQuantity(lines: SalesOrderLineInterface[], line: SalesOrderLineInterface) {
//     return this.personalisedLines(lines, line).reduce((total, item) => total + this.quantity(item), 0);
//   },

//   totalQuantity(lines: SalesOrderLineInterface[], line: SalesOrderLineInterface) {
//     return this.productLines(lines, line).reduce((total, item) => total + this.quantity(item), 0);
//   },

//   remainingPersonalisationQuantity(lines: SalesOrderLineInterface[], line: SalesOrderLineInterface) {
//     return this.totalQuantity(lines, line) - this.personalisedQuantity(lines, line);
//   },

//   quantity(line: SalesOrderLineInterface) {
//     const quantity = Number(line.Quantity);

//     return Number.isFinite(quantity) ? quantity : 0;
//   },

//   isPersonalised(line: SalesOrderLineInterface) {
//     return Boolean(line.Line_Notes?.trim());
//   },
// };

// export default LinesUtility;

import SalesOrderLineInterface from '@/interfaces/SalesOrderLineInterface';
import RecipeInterface from '@/interfaces/Recipe';

const LinesUtility = {
  productKey(line: SalesOrderLineInterface) {
    return `${line.External_Document_Line_No}`;
  },

  /**
   * Wszystkie linie należące do tego samego produktu.
   */
  productLines(lines: SalesOrderLineInterface[], line: SalesOrderLineInterface) {
    const key = this.productKey(line);

    return lines.filter((item) => this.productKey(item) === key);
  },

  totalProducts(lines: SalesOrderLineInterface[] = []) {
    return this.products(lines).length;
  },

  products(lines: SalesOrderLineInterface[] = []) {
    const products = new Map<string, SalesOrderLineInterface>();

    for (const line of lines) {
      const key = this.productKey(line);
      const currentProduct = products.get(key);

      if (!currentProduct || (this.isPersonalised(currentProduct) && !this.isPersonalised(line))) {
        products.set(key, line);
      }
    }

    return [...products.values()].sort((a, b) => a.External_Document_Line_No - b.External_Document_Line_No);
  },

  product(lines: SalesOrderLineInterface[], line: SalesOrderLineInterface) {
    return this.products(this.productLines(lines, line))[0];
  },

  recipes(lines: SalesOrderLineInterface[] = []) {
    return [
      ...new Set(
        lines
          .map((line) => ({
            product_item_no_2: line.Item_No_2.split(' ').slice(0, 2).join('+'),
            recipe_id: line.Line_Notes,
            image: line.Product_URL_3,
          }))
          .filter((line) => line.recipe_id?.trim()),
      ),
    ];
  },

  personalisedLines(lines: SalesOrderLineInterface[], line: SalesOrderLineInterface) {
    return this.productLines(lines, line).filter((item) => this.isPersonalised(item));
  },

  unpersonalisedLines(lines: SalesOrderLineInterface[], line: SalesOrderLineInterface) {
    return this.productLines(lines, line).filter((item) => this.isPersonalised(item) === false);
  },

  personalisedQuantity(lines: SalesOrderLineInterface[], line: SalesOrderLineInterface) {
    return this.personalisedLines(lines, line).reduce((total, item) => total + this.quantity(item), 0);
  },

  unpersonalisedQuantity(lines: SalesOrderLineInterface[], line: SalesOrderLineInterface) {
    return this.unpersonalisedLines(lines, line).reduce((total, item) => total + this.quantity(item), 0);
  },

  totalQuantity(lines: SalesOrderLineInterface[], line: SalesOrderLineInterface) {
    return this.productLines(lines, line).reduce((total, item) => total + this.quantity(item), 0);
  },

  remainingPersonalisationQuantity(lines: SalesOrderLineInterface[], line: SalesOrderLineInterface) {
    return this.unpersonalisedQuantity(lines, line);
  },

  groupByProduct(lines: SalesOrderLineInterface[] = []) {
    const groups = new Map<string, SalesOrderLineInterface[]>();

    for (const line of lines) {
      const key = this.productKey(line);
      const group = groups.get(key);

      if (group) {
        group.push(line);
      } else {
        groups.set(key, [line]);
      }
    }

    return [...groups.values()].flat();
  },

  quantity(line: SalesOrderLineInterface) {
    const quantity = Number(line.Quantity);
    return Number.isFinite(quantity) ? quantity : 0;
  },

  isPersonalised(line: SalesOrderLineInterface) {
    return Boolean(line.Line_Notes?.trim());
  },

  previousRecipes(line: SalesOrderLineInterface, recipes: RecipeInterface[]) {
    const { Item_No_2 = '' } = line;
    const product_id = Item_No_2.split(' ').slice(0, 2).join('+');
    // const product_id = Item_No_2.substring(0, Item_No_2.lastIndexOf(' '));

    return recipes
      .filter((recipe) => recipe.product_item_no_2 === product_id)
      .filter((recipe) => recipe.recipe_id !== line.Line_Notes);
  },
};

export default LinesUtility;
